import { Injectable } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './financial-institution-branch-search.actions';

@Injectable({
	providedIn: 'root',
})
export class FinancialInstitutionBranchSearchDispatch {
	@Dispatch()
	Search = (searchValue: string, institutionId?: string): actions.Search =>
		new actions.Search({ searchValue, institutionId });
}
